import { Attributes, NeoModel, Rules, Validation, ValueObject } from "@singularsystems/neo-core";
import { TextConstants } from "../../../Common/TextConstants";

@NeoModel
export default class ValuelessSecurityTransactionsReportCriteria extends ValueObject {
    @Rules.Required()
    public staticServiceProviderFileGroupingId: number = 0;

    public serviceProviderGroupingName: string = "";

    public rawAccountNumber: string = "";

    @Rules.Required()
    @Attributes.Date()
    public startDate: Date | null = new Date();

    @Rules.Required()
    @Attributes.Date()
    public endDate: Date | null = new Date();

    protected addBusinessRules(rules: Validation.Rules<this>): void {
        super.addBusinessRules(rules);
        rules.failWhen(c => c.startDate != null && c.endDate != null && c.startDate > c.endDate, TextConstants.Validation.StartDateBeforeEndDate);
    }
}